export type Weather = {
  location: string;
  forecast_datetime: string;
  weather_condition: WeatherConditionType | string;
  wind_degree: WindDegreeType;
  wind_speed: string;
};

export const WeatherConditionName = {
  Thunderstorm: "Thunderstorm",
  Drizzle: "Drizzle",
  Rain: "Rain",
  Snow: "Snow",
  Atmosphere: "Atmosphere",
  Clear: "Clear",
  Clouds: "Clouds",
} as const;

export type WeatherConditionType = (typeof WeatherConditionName)[keyof typeof WeatherConditionName];

export const WeatherCondition = {
  // 雷雨（雷を伴う雨）
  [WeatherConditionName.Thunderstorm]: {
    icon: "./img/icon-weather-thunderstorm.svg",
    i18n: "weather_thunderstorm",
  },
  // 霧雨（小雨より細かい雨）
  [WeatherConditionName.Drizzle]: {
    icon: "./img/icon-weather-drizzle.svg",
    i18n: "weather_drizzle",
  },
  // 雨
  [WeatherConditionName.Rain]: {
    icon: "./img/icon-weather-rain.svg",
    i18n: "weather_rain",
  },
  // 雪
  [WeatherConditionName.Snow]: {
    icon: "./img/icon-weather-snow.svg",
    i18n: "weather_snow",
  },
  // NOTE: ここで定義してない天気が返されるが、すべてAtmosphereとして表示する
  // 霧・煙・砂塵などの大気現象
  [WeatherConditionName.Atmosphere]: {
    icon: "./img/icon-weather-atmosphere.svg",
    i18n: "weather_atmosphere",
  },
  // 晴天
  [WeatherConditionName.Clear]: {
    icon: "./img/icon-weather-clear.svg",
    i18n: "weather_clear",
  },
  // 曇り
  [WeatherConditionName.Clouds]: {
    icon: "./img/icon-weather-clouds.svg",
    i18n: "weather_clouds",
  },
} as const;

export const getWeatherCondition = (type: WeatherConditionType | string): { icon: string; i18n: string } => {
  const w = WeatherCondition[type];
  return w || WeatherCondition[WeatherConditionName.Atmosphere];
};

export const WindDegreeName = {
  North: "north",
  NorthNorthEast: "north-northeast",
  NorthEast: "northeast",
  EastNorthEast: "east-northeast",
  East: "east",
  EastSouthEast: "east-southeast",
  SouthEast: "southeast",
  SouthSouthEast: "south-southeast",
  South: "south",
  SouthSouthWest: "south-southwest",
  SouthWest: "southwest",
  WestSouthWest: "west-southwest",
  West: "west",
  WestNorthWest: "west-northwest",
  NorthWest: "northwest",
  NorthNorthWest: "north-northwest",
} as const;

export type WindDegreeType = (typeof WindDegreeName)[keyof typeof WindDegreeName];

export const WindDegree = {
  [WindDegreeName.North]: { degree: 0, i18n: "north" },
  [WindDegreeName.NorthNorthEast]: { degree: 22.5, i18n: "north_northeast" },
  [WindDegreeName.NorthEast]: { degree: 45, i18n: "northeast" },
  [WindDegreeName.EastNorthEast]: { degree: 67.5, i18n: "east_northeast" },
  [WindDegreeName.East]: { degree: 90, i18n: "east" },
  [WindDegreeName.EastSouthEast]: { degree: 112.5, i18n: "east_southeast" },
  [WindDegreeName.SouthEast]: { degree: 135, i18n: "southeast" },
  [WindDegreeName.SouthSouthEast]: { degree: 157.5, i18n: "south_southeast" },
  [WindDegreeName.South]: { degree: 180, i18n: "south" },
  [WindDegreeName.SouthSouthWest]: { degree: 202.5, i18n: "south_southwest" },
  [WindDegreeName.SouthWest]: { degree: 225, i18n: "southwest" },
  [WindDegreeName.WestSouthWest]: { degree: 247.5, i18n: "west_southwest" },
  [WindDegreeName.West]: { degree: 270, i18n: "west" },
  [WindDegreeName.WestNorthWest]: { degree: 292.5, i18n: "west_northwest" },
  [WindDegreeName.NorthWest]: { degree: 315, i18n: "northwest" },
  [WindDegreeName.NorthNorthWest]: { degree: 337.5, i18n: "north_northwest" },
};
